import {translate} from '@/i18n';

/**
 * The browser tab, in the language on screen. Separate from the router wiring because it
 * has two triggers, not one: navigating somewhere else, and switching language where you
 * are. The second is easy to forget — every component re-renders on a language change,
 * but `document.title` is set imperatively and stays as it was until something sets it
 * again.
 */
export const documentTitleFor = (titleKey: string | undefined): string =>
  titleKey ? `${translate(titleKey)} — ${translate('app.name')}` : translate('app.name');

export const applyDocumentTitle = (titleKey: string | undefined): void => {
  document.title = documentTitleFor(titleKey);
};
